const styles = {
  imgArea: {
    border: '2px dashed',
    borderColor: 'divider',
    borderRadius: 2,
    p: 4,
    textAlign: 'center',
    cursor: 'pointer',
    transition: '0.2s',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'action.hover',
    },
  },
  img: {
    width: 200,
    height: 200,
    objectFit: 'cover',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
  },
  icon: {
    backgroundColor: 'white',
  },
};

export default styles;
